import Modal from './Modal';
import ModalHeader from './components/ModalHeader';
import ModalBody from './components/ModalBody';
import ModalFooter from './components/ModalFooter';
export { Modal, ModalHeader, ModalBody, ModalFooter };
export default Modal;